module.exports = __webpack_public_path__ + "static/media/team.18d9f953.PNG";